import { KioskStateType } from "../../KioskReducer";
import { useKioskState } from "./useKioskState";

const createSelectorHook = () => {
  function useSelectorKiosk<T>(callback: (state: KioskStateType) => T) {
    const state = useKioskState();
    return callback(state);
  }

  return useSelectorKiosk;
};

export const useSelectorKiosk = createSelectorHook();
